module.exports = __webpack_public_path__ + "static/media/Motorola Moto G.267aecd8.png";